var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 9C14.433 9 16 7.433 16 5.5C16 3.567 14.433 2 12.5 2C10.567 2 9 3.567 9 5.5C9 7.433 10.567 9 12.5 9ZM12.5 11C15.5376 11 18 8.53757 18 5.5C18 2.46243 15.5376 0 12.5 0C9.46243 0 7 2.46243 7 5.5C7 8.53757 9.46243 11 12.5 11Z",
    fill: "#8A8A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 23C23.3108 17.4764 18.3531 13.4762 12.5 13.4762C6.64695 13.4762 1.68917 17.4764 0 23H25ZM21.9501 21C19.9748 17.6652 16.4506 15.4762 12.5 15.4762C8.54945 15.4762 5.02524 17.6652 3.0499 21H21.9501Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGrey);
export default __webpack_public_path__ + "static/media/userGrey.4794baf20f59a991089b39fdf09e78ea.svg";
export { ForwardRef as ReactComponent };